import React, { useState, useRef, useCallback } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { login } from "../../api/auth";
import { useNavigate } from "react-router-dom";
import ScrollView from 'devextreme-react/scroll-view';
import './login.scss';
import appInfo from '../../configs/app-info';
import { Button } from 'devextreme-react/button';

import Form, {
    Item,
    Label,
    ButtonItem,
    ButtonOptions,
    RequiredRule,
    SimpleItem
} from 'devextreme-react/form';
import LoadIndicator from 'devextreme-react/load-indicator';
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import { Controller, useForm } from "react-hook-form";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import Icon from "../../components/icon";
import FormControlLabel from "@mui/material/FormControlLabel";
import Box from "@mui/material/Box";
import { color } from "@mui/system";

const usernameEditorOptions = { stylingMode: 'filled', placeholder: 'Username', mode: 'username' };
const passwordEditorOptions = { stylingMode: 'filled', placeholder: 'Password', mode: 'password' };

const Index = () => {
    const { loginUser } = useAuth();
    const navigate = useNavigate(); // Hook untuk navigasi

    const [credentials, setCredentials] = useState({ username: "", password: "" });
    const [txtErrors, setTxtError] = useState("");
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState<boolean>(false)
    const formData = useRef({ username: '', password: '' });

    const defaultValues = {
        password: '',
        username: ''
    }

    interface FormData {
        username: string
        password: string
    }

    const {
        control,
        setError,
        handleSubmit,
        formState: { errors }
    } = useForm({
        defaultValues,
        mode: 'onBlur',
    })

    const onSubmit = async (data: FormData) => {
        const { username, password } = data
        setLoading(true);
        // data.preventDefault();
        try {
            setTxtError("");
            const response = await login(data);

            if (response.success != false) {
                setLoading(false);
                loginUser(response);
                navigate("/");
            } else {
                setLoading(false)
                setTxtError(response.message);
            }
        } catch (error: any) {
            setTxtError(error.message || "Login failed. Please try again.");
        }
    }

    return (
        <ScrollView
            height="100%"
            width="100%"
            style={{
                backgroundImage: `url(${appInfo.bgLogin})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                minHeight: "100vh",
            }}
        >
            <div
                style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    minHeight: "100vh",
                    padding: 16,
                }}
            >
                <div
                    className="dx-card"
                    style={{
                        width: "100%",
                        maxWidth: 480, // lebih besar untuk desktop
                        padding: 0, // padding diatur per bagian
                        borderRadius: 12,
                        boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
                        backgroundColor: "#fff",
                    }}
                >
                    {/* Header Logo */}
                    <div
                        style={{
                            backgroundImage: `url('./background/header.png')`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                            padding: "40px 16px", // lebih tinggi di desktop
                            textAlign: "center",
                            color: "#fff",
                        }}
                    >
                        <img
                            src={appInfo.logo2}
                            alt="Logo"
                            style={{
                                width: 160,
                                maxWidth: "100%",
                                marginBottom: 8,
                            }}
                        />
                    </div>

                    {/* Title & Subtitle */}
                    <div style={{ padding: "24px 24px 0 24px", marginBottom: 20 }}>
                        <div style={{ fontSize: 22, fontWeight: 600, marginBottom: 4 }}>
                            Selamat datang di My Little Fairies
                        </div>
                        <div style={{ fontSize: 15, color: "#666" }}>
                            Silahkan login dengan akun anda
                        </div>
                    </div>

                    {/* Form */}
                    <form onSubmit={handleSubmit(onSubmit)} style={{ padding: "0 24px 24px" }}>
                        <Form labelLocation="top" showColonAfterLabel={false} colCount={1}>
                            <Item>
                                <Label text="Username" />
                                <Controller
                                    name="username"
                                    control={control}
                                    rules={{ required: "Username wajib diisi" }}
                                    render={({ field }) => (
                                        <input
                                            {...field}
                                            type="text"
                                            className="dx-texteditor-input"
                                            placeholder="Username"
                                            autoFocus
                                            style={{
                                                width: "100%",
                                                padding: "10px",
                                                border: "1px solid #ccc",
                                                borderRadius: 4,
                                            }}
                                        />
                                    )}
                                />
                            </Item>

                            <Item>
                                <Label text="Password" />
                                <Controller
                                    name="password"
                                    control={control}
                                    rules={{ required: "Password wajib diisi" }}
                                    render={({ field }) => (
                                        <input
                                            {...field}
                                            type="password"
                                            className="dx-texteditor-input"
                                            placeholder="Password"
                                            style={{
                                                width: "100%",
                                                padding: "10px",
                                                border: "1px solid #ccc",
                                                borderRadius: 4,
                                            }}
                                        />
                                    )}
                                />
                            </Item>
                        </Form>

                        {txtErrors && (
                            <div
                                style={{
                                    color: "#d32f2f",
                                    fontSize: 13,
                                    marginTop: 8,
                                    textAlign: "center",
                                }}
                            >
                                {txtErrors}
                            </div>
                        )}

                        <div style={{ textAlign: "left", marginTop: 20 }}>
                            <Button
                                text={loading ? "Loading..." : "LOGIN"}
                                type="default"
                                stylingMode="contained"
                                width="100%"
                                useSubmitBehavior={true}
                                disabled={loading}
                                style={{
                                    height: '40px',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    backgroundColor: '#E48866',
                                    color: '#fff',
                                }}
                            />
                        </div>
                    </form>
                </div>
            </div>
        </ScrollView>

    );
};

export default Index;
